import {BarcodeType} from "./barcode";

export class SaleColPrintAsBarCodeSettings {
	Enabled:boolean = false;
	BarCodeType:BarcodeType = BarcodeType.CODE128;
	Height:number = 10;

	public constructor(data?:any){
		if (!data) return;
		this.Enabled = data.Enabled;
		this.BarCodeType = data.BarCodeType;
		this.Height = data.Height;
	}

	public getJSON(){
		return {
			Enabled: this.Enabled,
			BarCodeType: this.BarCodeType,
			Height: this.Height,
		};
	}
}
